import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import { FaLinkedinIn as LinkedinIcon } from "react-icons/fa"
import { FaYoutube as YoutubeIcon } from "react-icons/fa"
import { FaInstagram as InstagramIcon } from "react-icons/fa"
import { FaFacebookF as FacebookIcon } from "react-icons/fa"
import { FaTwitter as TwitterIcon } from "react-icons/fa"

const supported = {
  linkedin: {
    icon: LinkedinIcon,
  },
  instagram: {
    icon: InstagramIcon,
  },
  youtube: {
    icon: YoutubeIcon,
  },
  facebook: {
    icon: FacebookIcon,
  },
  twitter: {
    icon: TwitterIcon,
  },
}

const SocialNetworks = props => {
  const { className, socialNetworks } = props

  const [parsed] = useState(() => {
    return Object.keys(socialNetworks).reduce((prev, curr) => {
      const output = prev
      if (Object.keys(supported).includes(curr)) {
        output[curr] = {
          ...socialNetworks[curr],
          icon: supported[curr].icon,
        }
      }
      return output
    }, {})
  })

  return (
    <div className={className}>
      <ul className="social-networks-items">
        {Object.keys(parsed).map((social, i) => {
          if (parsed[social].cta && parsed[social].url && parsed[social].icon) {
            const SocialIcon = parsed[social].icon
            return (
              <li
                className="social-networks-item"
                key={`social-${social}-${i}`}
              >
                <a
                  href={parsed[social].url}
                  rel="nofollow"
                  title={parsed[social].cta}
                >
                  <SocialIcon></SocialIcon>
                </a>
              </li>
            )
          }
          return null
        })}
      </ul>
    </div>
  )
}

SocialNetworks.propTypes = {
  className: PropTypes.string,
  socialNetworks: PropTypes.object,
}

const StyledSocialNetworks = styled(SocialNetworks)`
  .social-networks-items {
    display: flex;
    justify-content: center;
  }

  .social-networks-item {
    padding: 0.5rem;
  }
`

export default StyledSocialNetworks
export { SocialNetworks }
